// Use it anywhere - it persists across re-renders
// Get the original price anytime
export const getOriginalPrice = (productId: string) => {
  const stored = sessionStorage.getItem('originalBasketPrices');
  if (stored) {
    const originalPrices = JSON.parse(stored);
    return originalPrices[productId];
  }
  return null;
};
